<template>
  <div v-loading.fullscreen.lock="config.loading.save" element-loading-text="Aguarde enquanto a liberação é concluída...">
    <ed-modal
      :title="'LIBERAR ASO' + title"
      :modal="parent.showLiberacao"
      :loadingSave="config.loading.save"
      :loading="config.loading.content"
      :onSave="asoLiberada ? null : salvar"
      :currentTab="tagConfig"
    >
      <div slot="modal-content">
        <el-tabs type="border-card" v-model="tagConfig" @tab-click="handleClick">
          <el-tab-pane label="Config" name="tab-cadastro">
            <span slot="label"><i class="fa fa-unlock"></i> Liberar ASO</span>

            <div class="aso-alert" v-if="asoLiberada">
              <el-alert
                title="Consulta já liberada"
                :closable="false"
                description="A consulta já está liberada e não pode ser liberada novamente."
                type="success"
                show-icon
              />
            </div>

            <ed-form v-if="!asoLiberada" :data="formData" :config="config" :itens="formItems" :response="response">
              <div slot="form-footer"></div>
            </ed-form>
          </el-tab-pane>

          <el-tab-pane label="Config" name="tab-historico">
            <span slot="label">
              <i :class="'fa fa-history' + (novaLiberacao ? ' faa-flash animated' : '')"></i>
              Histórico de Liberação
            </span>

            <TableView :onSearch="getConsultaLiberacao" :tableHead="tableHead" :tableData="tableData" :loadingTable="config.loading.table" :pagination="pagination" :response="response" disableInputSearch disabledConfigCell disableCheckAll />
          </el-tab-pane>
        </el-tabs>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import TableView from "common/table";
import Rest from "common/rest";
import Fct from "common/fct";
import EdModal from "common/modal";
import EdForm from "common/form";
import FormItems from "../_form/liberacao-aso";

export default {
  name: "empresa",
  components: { TableView, EdModal, EdForm },
  mixins: [Rest, Fct],
  props: {
    parent: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "parent.consulta.id"() {
      this.carregarDados();
    },
    "parent.showLiberacao"() {
      this.carregarDados();
    },
    "formData.aptidao"() {
      this.handleAptidao();
    },
  },
  data() {
    return {
      trabalhosEspeciais: [],
      config: {
        tipo: [53, 185, 189],
        click: {
          exames: _.debounce(this.getExame, 1000),
        },
        list: {
          exames: [],
        },
        loading: {
          save: false,
          table: false,
          content: false,
          exames: false,
        },
        disabled: {
          id_tipo_status: false,
          obs: false,
        },
      },
      formData: {
        id: 0,
        id_tipo_status: 69,
        aptidao: null,
        obs: null,
        arquivo: null,
        exames: [],
      },
      pagination: {},
      response: {},
      tableHead: [],
      tableData: [],
      formItems: [],
      novaLiberacao: false,
      tagConfig: "tab-cadastro",
      title: "",
    };
  },

  created() {},

  mounted: function () {
    this.montarTableHead();
  },

  // Computed para verificar se a consulta já está liberada (tipo_status.id === 66)
  computed: {
    asoLiberada() {
      return (
        this.parent &&
        this.parent.consulta &&
        this.parent.consulta.tipo_status &&
        this.parent.consulta.tipo_status.id === 66
      );
    },
  },

  methods: {
    handleClick(tab, event) {
      this.novaLiberacao = false;
    },

    carregarDados: function () {
      if (!this.parent.consulta) return;

      var id_emp = this.parent.consulta.empresa ? this.parent.consulta.empresa.id : null;

      if (!id_emp) {
        this.getConsulta();
        this.getConsultaLiberacao();
        return;
      }

      this.config.loading.content = true;

      this.get("empresa/" + id_emp + "/trabalho-especial").then((result) => {
        result = result[0];

        if (result.status == 200) {
          this.trabalhosEspeciais = result.data || [];
        } else {
          this.trabalhosEspeciais = [];
        }

        this.montarFormItems();
        this.montarFormData();
        this.montarDisabled();
        this.montarTableHead();
        this.getConsulta();
        this.getConsultaLiberacao();
      });
    },

    montarFormItems: function () {
      var baseItems = FormItems.slice();
      var teItems = [];

      for (var i = 0; i < this.trabalhosEspeciais.length; i++) {
        var te = this.trabalhosEspeciais[i];
        teItems.push({
          class: 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
          type: 'select-tipo',
          field: te.field,
          label: te.label,
          valor: 'valor',
          tipo: te.tipo,
          rules: ['required']
        });
      }

      // Inserir campos TE após aptidão (índice 0) e antes de exames (índice 1)
      this.formItems = [baseItems[0]].concat(teItems, baseItems.slice(1));
    },

    montarFormData: function () {
      var formData = {
        id: 0,
        id_tipo_status: 69,
        aptidao: null,
        obs: null,
        arquivo: null,
        exames: [],
      };

      for (var i = 0; i < this.trabalhosEspeciais.length; i++) {
        formData[this.trabalhosEspeciais[i].field] = null;
      }

      this.formData = formData;
    },

    montarDisabled: function () {
      var disabled = {
        id_tipo_status: false,
        obs: false,
      };

      for (var i = 0; i < this.trabalhosEspeciais.length; i++) {
        disabled[this.trabalhosEspeciais[i].field] = false;
      }

      this.$set(this.config, 'disabled', disabled);
    },

    montarTableHead: function () {
      var head = [
        { key: "data", sortable: true, width: "120px", label: "Data" },
        { key: "usuario", sortable: true, label: "Usuário" },
        { key: "status", sortable: true, label: "Status" },
        { key: "aptidao", sortable: true, show_html: true, label: "Aptidão" },
      ];

      for (var i = 0; i < this.trabalhosEspeciais.length; i++) {
        var te = this.trabalhosEspeciais[i];
        head.push({
          key: "te_" + te.field,
          sortable: true,
          show_html: true,
          label: te.label,
        });
      }

      head.push({ key: "exames", sortable: true, label: "Exames Alterados" });
      head.push({ key: "obs", sortable: true, label: "Obs" });

      this.tableHead = head;
    },

    handleAptidao() {
      this.config.disabled.id_tipo_status = this.formData.aptidao == "2" || this.formData.aptidao == "5";

      for (var i = 0; i < this.trabalhosEspeciais.length; i++) {
        this.$set(this.config.disabled, this.trabalhosEspeciais[i].field, this.formData.aptidao == "5");
      }

      if (this.formData.aptidao == "1") {
        this.formData.id_tipo_status = 66;
      } else if (this.formData.aptidao == "2") {
        this.formData.id_tipo_status = 67;
      } else if (this.formData.aptidao == "5") {
        this.formData.id_tipo_status = 70;
      }
    },

    getExame() {},

    getConsulta: function () {
      if (!this.parent.consulta) return;

      this.config.loading.content = true;
      this.config.list.exames = [];

      this.get("empresa/consulta/" + this.parent.consulta.id_con).then((result) => {
        result = result[0];
        this.config.loading.content = false;

        if (result.status == 200) {
          var formData = {
            id_tipo_status: result.data.tipo_status ? result.data.tipo_status.id : null,
            aptidao: this.toString(result.data.aptidao) == "0" ? null : this.toString(result.data.aptidao),
            obs: result.data.obs,
            exames: [],
          };

          for (var i = 0; i < this.trabalhosEspeciais.length; i++) {
            var field = this.trabalhosEspeciais[i].field;
            formData[field] = this.toString(result.data[field]) == "0" ? null : this.toString(result.data[field]);
          }

          this.formData = formData;

          for (var i = 0; i < result.data.exames.length; i++) {
            var element = result.data.exames[i];

            if (element.dem == 0) {
              this.config.list.exames.push(element.exame);
            }
          }
        }
      });
    },

    getConsultaLiberacao: function (_search, _page, _pagination) {
      if (!this.parent.consulta) return;

      this.config.loading.table = true;
      this.tagConfig = "tab-cadastro";
      this.title = " Nº " + this.parent.consulta.id_con + " - " + this.parent.consulta.empresa.nome + " - " + this.parent.consulta.funcionario.nome;

      this.get("empresa/consulta/liberacao/" + this.parent.consulta.id_con, { search: _search, page: _page, pagination: _pagination }).then((result) => {
        result = result[0];

        if (result.status == 200) {
          this.formataData(result);
        }
      });
    },

    formatarTeIcon: function (valor) {
      if (valor == "1") return '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO"/>';
      if (valor == "2") return '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO"/>';
      if (valor == "3") return '<i title="N/A">-</i>';
      return "";
    },

    formataData: function (result) {
      var data = result.data.data,
        tableData = [],
        self = this,
        pagination = result.data;

      for (var i = 0; i < data.length; i++) {
        var aptidao = "";

        if (data[i].aptidao == "1") aptidao = '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO PARA A FUNÇÃO"/>';
        else if (data[i].aptidao == "2") aptidao = '<i class="fa fa-exclamation-triangle fa-2x" style="color:orange" title="APTO COM RESTRIÇÕES"/>';
        else if (data[i].aptidao == "5" || data[i].aptidao == "6") aptidao = '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO PARA A FUNÇÃO"/>';

        var item = {
          data: this.toDate(data[i].created, false),
          usuario: data[i].usuario ? data[i].usuario.usuario : null,
          status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
          aptidao: aptidao,
          exames: data[i].exame_alt ? data[i].exame_alt.join(", ") : "",
          obs: data[i].obs,
          _data: data[i],
          options: {},
          buttons: [],
        };

        for (var j = 0; j < this.trabalhosEspeciais.length; j++) {
          var te = this.trabalhosEspeciais[j];
          item["te_" + te.field] = this.formatarTeIcon(data[i][te.field]);
        }

        tableData.push(item);
      }

      this.pagination = pagination;
      this.tableData = tableData;
      this.config.loading.table = false;
    },

    salvar: function () {
      this.$confirm(
        "Ao inserir uma NOVA LIBERAÇÃO não será possível desfazer a ação. Deseja prosseguir?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.config.loading.save = true;
        this.response = {};

        this.post(
          "empresa/consulta/liberacao/" + this.parent.consulta.id_con + "/cadastrar",
          this.formData
        ).then((result) => {
          result = result[0];
          this.response = result;

          this.config.loading.save = false;

          if (result.status == 200) {
            this.edMsg("Liberação cadastrado com sucesso!");

            this.novaLiberacao = true;
            this.tagConfig = "tab-historico";

            this.formataData(result);
            this.getConsulta();
            this.parent.getConsulta();

          }
        });
      });
    },

  },
};
</script>

<style scoped>
.aso-alert {
  display: flex;
  justify-content: center; /* centraliza o bloco do alert horizontalmente */
  align-items: center; /* centraliza verticalmente */
  min-height: 120px; /* garante espaço para centralização vertical */
  margin: 12px 0;
}
.aso-alert .el-alert {
  width: 100%;
  max-width: 820px; /* limita largura para não ocupar toda a modal */
}
.aso-alert .el-alert__title {
  font-size: 28px; /* aumenta o título */
  font-weight: 700;
  text-align: center; /* centra o texto do título */
}
.aso-alert .el-alert__description {
  font-size: 18px; /* aumenta a descrição */
  text-align: center; /* centra o texto da descrição */
}
</style>



// WEBPACK FOOTER //
// liberar-aso.vue?337eb3d2